/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'
import LayoutView from '@/layout/layout'

const mobileRouter = {
	path: '/mobile',
	component: Layout,
	redirect: 'noRedirect',
	name: '移动端',
	id: 1600000,
	meta: {
		title: '移动端',
		icon: 'component',
		roles: [1600000]
	},
	children: [
		{
			path: 'basicSet',
			component: () =>
				import(/* webpackChunkName: "noticeruleset" */ '@/leniuview/mobile/basicSet'),
			name: '基础设置',
			id: 1601000,
			meta: { title: '基础设置', roles: [1601000] }
		},
		{
			path: 'platformSet',
			component: () =>
				import(/* webpackChunkName: "noticeruleset" */ '@/leniuview/mobile/platformSet'),
			name: '平台设置',
			id: 1602000,
			meta: { title: '平台设置', roles: [1602000] }
		},
		// {
		// 	path: 'homedecoration',
		// 	component: () =>
		// 		import(/* webpackChunkName: "homedecoration" */ '@/leniuview/basesetting/mobile/homedecoration'),
		// 	name: '首页装修',
		// 	id: 207900,
		// 	meta: {
		// 		title: '首页装修',
		// 		noCache: true,
		// 		roles: [207900]
		// 	}
		// },
		// {
		// 	path: 'mydecoration',
		// 	component: () =>
		// 		import(/* webpackChunkName: "homedecoration" */ '@/leniuview/mobile/mydecoration'),
		// 	name: '我的装修',
		// 	id: 207200,
		// 	meta: {
		// 		title: '我的装修',
		// 		noCache: true,
		// 		roles: [207200]
		// 	}
		// },
		// {
		// 	path: 'appletbanner',
		// 	component: () =>
		// 		import(/* webpackChunkName: "appletbanner" */ '@/leniuview/mobile/appletbanner'),
		// 	name: '轮播图',
		// 	id: 207100,
		// 	meta: {
		// 		title: 'lnbasesetting.lunbo',
		// 		noCache: true,
		// 		roles: [207100]
		// 	}
		// },
		// {
		// 	path: 'complaint',
		// 	component: () =>
		// 		import(/* webpackChunkName: "complaint" */ '@/leniuview/mobile/complaint'),
		// 	name: '投诉建议',
		// 	id: 604000,
		// 	meta: {
		// 		title: 'notice.tousu',
		// 		roles: [604000]
		// 	}
		// },
		{
			path: 'evaManeager',
			component: LayoutView,
			name: '评价管理',
			id: 605000,
			meta: {
				title: '评价管理',
				roles: [605000]
			},
			redirect: 'order',
			children: [
				{
					path: 'order',
					component: () =>
						import(/* webpackChunkName: "order" */ '@/leniuview/mobile/pingjia/evaManeager'),
					name: '订单评价',
					id: 605100,
					meta: {
						title: '订单评价',
						roles: [605100]
					}
				},
				{
					path: 'canteen',
					component: () =>
						import(/* webpackChunkName: "canteen" */ '@/leniuview/mobile/pingjia/conteenPj'),
					name: '食堂评价',
					id: 605200,
					meta: {
						title: '食堂评价',
						roles: [605200]
					}
				},
				{
					path: 'pjConfig',
					component: () =>
						import(/* webpackChunkName: "pjConfig" */ '@/leniuview/mobile/pingjia/pjConfig'),
					name: '评价配置',
					meta: {
						title: '评价配置',
						// noCache: true,
						roles: [605200]
					},
					hidden: true
				},
				{
					path: 'pjSum',
					component: () =>
						import(/* webpackChunkName: "complaint" */ '@/leniuview/mobile/pingjia/pjSum'),
					name: '评价统计',
					meta: {
						title: '评价统计',
						roles: [605200],
						noCache: true
					},
					hidden: true
				}
			]
		},
		{
			path: 'dishLikes',
			component: () =>
				import(/* webpackChunkName: "noticeruleset" */ '@/leniuview/mobile/dishLikes'),
			redirect: 'dishLikes/dishLikesStatistics',
			name: '菜品点赞',
			id: 207300,
			meta: { title: '菜品点赞', roles: [207300] },
			children: [
				{
					path: 'dishLikesStatistics',
					component: () =>
						import('@/leniuview/mobile/dishLikesStatistics'),
					name: '菜品点赞统计',
					meta: { title: '菜品点赞统计', roles: [207300] },
					hidden: true
				},
				{
					path: 'dishLikesRelease',
					component: () =>
						import('@/leniuview/mobile/dishLikesRelease'),
					name: '菜品点赞发布',
					meta: { title: '菜品点赞发布', roles: [207300] },
					hidden: true
				}
			]
		}
	]
}

export default mobileRouter
